<a (click)="handleClick($event)" class="dropdown-item !flex py-1">
  <div [class.gap-x-2]="hasIcon" class="inline-flex text-sm w-full h-full">
    <div class="place-self-center">
      <ng-content select="[icon]"></ng-content>
    </div>
    <span class="place-self-center">{{ label }}</span>
  </div>
</a>
